
define('app/board/views/draftBoardView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickSummaryCollection',
	'known/models/leagueInstanceModel',
	'known/models/userModel',
	'app/board/models/pickModel',
	'app/board/views/teamHeaderView',
	
	//Templates
	'text!app/board/templates/pickBoardTemplate.html'
], function($, _, Backbone, PickSummaryCollection, LeagueInstanceModel, UserModel, PickModel, TeamHeaderView, pickBoardHtml){
	var PickView = Backbone.View.extend({
		initialize: function(options) {
			this.pickSummary = options.pickSummary;
			this.leagueInst = options.leagueInst;
			this.user = options.user;
			this.draftOptions = options.draftOptions;
			this.prodConfig = options.prodConfig;
			this.pickCollection = options.pickCollection;
			this.firstRender = true;
			this.posColors = options.posColors;
			this.displayTeam = options.displayTeam;
			
			this.template = _.template(pickBoardHtml.trim());
			
			this.listenTo(this.pickSummary, 'reset', this.render);
			this.listenTo(this.pickSummary, 'change', this.render);
			this.listenTo(this.user, 'change', this.pickOwnerRender);
			this.listenTo(this.draftOptions, 'change', this.setPickStyles);
			this.listenTo(this.posColors, 'change', this.setPickStyles);
			
			_.bindAll(this, 'openDelPickPopup');
			_.bindAll(this, 'openAddPickPopup');
		},
		
		render: function () {
			var lastName = '';
			var firstName = this.pickSummary.get('fName') ? this.pickSummary.get('fName') : '&nbsp;';
			
			var playedSelected = false;
			if(!this.pickSummary.get('lName')){
				
				if(this.leagueInst.get('draftType') == 'AUCTION'){
					lastName = this.pickSummary.get('round');
					firstName = '&nbsp;';
				} else if(this.prodConfig.TRIAL == 'true' && this.pickSummary.get('round') > parseInt(this.prodConfig.TRIALRDS)){
					firstName = parseInt(this.prodConfig.TRIALRDS) + ' Round';
					lastName = 'Trial';
				} else {
					firstName = this.pickSummary.get('round') 
							+ '.' 
							+ this.pickSummary.get('posInRound');
					lastName = this.pickSummary.get('ovrPickNum');
				}				
			} else if(this.pickSummary.get('keeper')){
				lastName = this.pickSummary.get('lName') + '<sup>(K)</sup>';
				playedSelected = true;
			} else if(this.pickSummary.get('autoDrafted')){
				lastName = this.pickSummary.get('lName') + '<sup>(A)</sup>';
				playedSelected = true;
			} else {
				lastName = this.pickSummary.get('lName');
				playedSelected = true;
			}
			
			if(this.leagueInst.get('draftType') == 'AUCTION'
					&& this.pickSummary.get('auctionValue') 
					&& this.pickSummary.get('auctionValue') > 0){
				lastName = '$' +this.pickSummary.get('auctionValue') + ' ' + lastName;
			}
			
			var html = $(this.template({
				pickNum: this.pickSummary.get('id'),
				playerPos: this.pickSummary.get('playerPos') ? this.pickSummary.get('playerPos') : '&nbsp;',
				keeper: this.pickSummary.get('keeper') ? 'keeper' : '',
				byeWeek: (this.pickSummary.get('byeWeek') && this.pickSummary.get('byeWeek') > 0)  ? this.pickSummary.get('byeWeek') : '&nbsp;',
				teamAbbr: this.pickSummary.get('teamAbbr') ? this.pickSummary.get('teamAbbr') : '&nbsp;',
				roundPos: this.pickSummary.get('posInRound') ? this.pickSummary.get('posInRound') : '&nbsp;',
				fName: firstName,
				lName: lastName}));
			
			if(playedSelected){
				$(html).removeClass('emptyPick');
				$(html).addClass('playerPicked');
			} else {
				$(html).addClass('emptyPick');
				$(html).removeClass('playerPicked');
			}
			
			if(this.displayTeam){
				$(html).find('.pickTeamOwner').html(this.leagueInst.getTeam(this.pickSummary.get('fantasyTeamId')).get('teamName'));
				$(html).find('.pickTeamOwner').show();
			}
			
			this.setPickElStyle(html);
			
			$(html).find("#delPickBtn" + this.pickSummary.get('id')).dropdown();
			$(html).find("#addPickBtn" + this.pickSummary.get('id')).dropdown();
			
			$(html).find("#delPickBtn" + this.pickSummary.get('id')).on('click', this.openDelPickPopup);
			$(html).find("#addPickBtn" + this.pickSummary.get('id')).on('click', this.openAddPickPopup);
			
			if(this.firstRender == true){
				this.el = html;
				//this.setElement(html);
				this.firstRender = false;
			} else {
				var oldEl = $(this.el);
				
				oldEl.find("#addPickBtn" + this.pickSummary.get('id')).off('click', this.openAddPickPopup);
				oldEl.find("#delPickBtn" + this.pickSummary.get('id')).off('click', this.openDelPickPopup);
				
				this.setElement(html);
				oldEl.replaceWith(html);
			}
			
			this.pickOwnerRender();
			
			return this;
		},
		
		setPickStyles: function() {
			this.setPickElStyle(this.el);
		},
		
		setPickElStyle: function(el) {
			var color = this.posColors.retrievePosColor(this.pickSummary.get('playerPos'));
			
			$(el).css({
				'font-size': this.draftOptions.get('fontSize') + 'px', 
				'line-height': this.draftOptions.get('fontHeight') + 'px',
				'min-width': this.draftOptions.get('pickWidth') + 'px', 
				'max-width': this.draftOptions.get('pickWidth') + 'px',
				'background-color': color,
				'padding-top': Math.ceil(this.draftOptions.get('playerLargeFontSize')/20) + 'px',
		    	'padding-right': Math.ceil(this.draftOptions.get('playerLargeFontSize')/10) + 'px',
		    	'padding-bottom': Math.ceil(this.draftOptions.get('playerLargeFontSize')/20) + 'px',
		    	'padding-left': Math.ceil(this.draftOptions.get('playerLargeFontSize')/10) + 'px', });
			/*$(el).css({
				'font-size': this.draftOptions.get('fontSize') + 'px', 
				'line-height': this.draftOptions.get('fontHeight') + 'px',
				'width': this.draftOptions.get('pickWidth') + 'px', 
				'background-color': color}); */ //Fixed Header Revert
			$(el).find(".playerFName").css({
				'font-size': this.draftOptions.get('playerSmallFontSize') + 'px', 
				'line-height': this.draftOptions.get('playerSmallFontHeight') + 'px',
			    'padding-top': Math.ceil(this.draftOptions.get('playerLargeFontSize')/8) + 'px'});
			$(el).find(".playerLName").css({
				'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
				'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
			$(el).parent().find(".draftRound").css({
				'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
				'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
			
			if(this.draftOptions.get('hideFName')){
				$(el).find(".playerFName").css({'display': 'none'});
				$(el).find(".playerLName").css({'clear': 'none'});
			} else {
				$(el).find(".playerFName").css({'display': ''});
				$(el).find(".playerLName").css({'clear': 'both'});
			}
			
			if(this.draftOptions.get('hidePlayerInfo')){
				$(el).find(".playerPos").css({'display': 'none'});
				$(el).find(".playerTeam").css({'display': 'none'});
				$(el).find(".playerBye").css({'display': 'none'});
			} else {
				$(el).find(".playerPos").css({'display': ''});
				$(el).find(".playerTeam").css({'display': ''});
				$(el).find(".playerBye").css({'display': ''});
			}
			
			if(this.draftOptions.get('hideRoundPosInfo')){
				$(el).find(".roundPos").css({'display': 'none'});
			} else {
				$(el).find(".roundPos").css({'display': ''});
			}
		},
		
		pickOwnerRender: function () {
			var teamOwner = this.leagueInst.getTeamOwner(this.pickSummary.get('fantasyTeamId'));
			var userName = this.user.get('userName');
			var isAssistant = this.leagueInst.isAssistant(userName);
			
			if(this.prodConfig.TRIAL == 'true' && this.pickSummary.get('round') > parseInt(this.prodConfig.TRIALRDS)){
				$(this.el).removeClass('pickOwner');
			} else if(isAssistant || userName.toUpperCase() == teamOwner.toUpperCase()){
				$(this.el).addClass('pickOwner');
				
				if(!isAssistant && !this.leagueInst.get('undoEnabled')){
					$(this.el).find("#delPickBtn" + this.pickSummary.get('id')).css({'display': 'none'});
				} else {
					$(this.el).find("#delPickBtn" + this.pickSummary.get('id')).css({'display': ''});
				}
			} else {
				$(this.el).removeClass('pickOwner');
			}
			
			//Change color of button for commish/assistants
			if(isAssistant && userName.toUpperCase() != teamOwner.toUpperCase()){
				$(this.el).find('.addPickBtn').removeClass('btn-success');
				$(this.el).find('.addPickBtn').addClass('btn-info');
			} else {
				$(this.el).find('.addPickBtn').removeClass('btn-info');
				$(this.el).find('.addPickBtn').addClass('btn-success');
			}
		},		
		
		openDelPickPopup: function (event) {
			$(document).trigger('draftApp:delPickSum', [this.pickSummary.get('id')]);
			
			var width = $(document).width();
			var height = $(document).height();
			
			var popupRight = width - event.pageX;
			var popupTop = event.pageY + 15;
			
			if(popupRight > (width - 225)){
				popupRight = width - 225;
			}
			if(popupTop > (height -300)){
				popupTop = height -300;
			}
			
			if(popupTop < 0){
				popupTop = 15;
			}
			
			$('#delPickPopup .dropdown-menu').css('top', popupTop);
			$('#delPickPopup .dropdown-menu').css('right', popupRight);
		},
		
		openAddPickPopup: function (event) {	
			//230/322
			$(document).trigger('draftApp:addPickSum', [this.pickSummary.get('id')]);
			
			var width = $(document).width();
			var height = $(document).height();
			
			var popupRight = width - event.pageX;
			var popupTop = event.pageY -161;
			
			if(popupRight > (width - 240)){
				popupRight = width - 240;
			}
			if(popupTop > (height -325)){
				popupTop = height -325;
			}
			
			if(popupTop < 0){
				popupTop = 15;
			}
			
			$('#draftPlayerPopup .dropdown-menu').css('top', popupTop);
			$('#draftPlayerPopup .dropdown-menu').css('right', popupRight);
			
			setTimeout(function() { $('#playerSearchInput').focus();}, 200);
		}
	});
	
	var StandardOrderView = Backbone.View.extend({
		el: $("#customStandardDraftBoardTable"),
		
		initialize: function(options) {
			this.leagueInst = options.leagueInst;
			this.user = options.user;
			this.pickSummaries = options.pickSummaries;
			this.draftOptions = options.draftOptions;
			this.posColors = options.posColors;
			this.prodConfig = options.prodConfig;
			this.pickCollection = options.pickCollection;
			this.draftStatusModel = options.draftStatusModel;
			
			this.pickViews = [];
		},
		
		render: function () {		
			this.$("tbody").empty();
			this.renderRounds();
			
			//$('#draftBoardView').show();
			
			return this;
		},
		
		renderRounds: function () {
			var numRounds = this.leagueInst.get('numRounds');
			
			if(this.leagueInst.get('draftType') == 'CUSTOM'){
				var picksPerRound = new Array(numRounds);
				var maxPicksInRound = 0;
				
				for (var i = 1; i <= numRounds; i++) {
					var roundPicks = this.pickCollection.getPicksByRound(i);
					
					if(roundPicks.length > maxPicksInRound){
						maxPicksInRound = roundPicks.length;
					}
						
					picksPerRound[i] = roundPicks;
				}
				
				for (var i = 1; i <= numRounds; i++) {
					var roundRow = $('<tr></tr>');
					
					var curRound = i;
					var roundPicks = picksPerRound[i];
					
					roundRow.append('<td class="draftRound">' + i + '</td>');
					
					roundRow.find(".draftRound").css({
						'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
						'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
					
					for (var j = 1; j <= roundPicks.length; j++) {
						var pickSum = this.pickSummaries.get(this.pickSummaries.getPosRoundId(curRound, j));
						
						if(pickSum){
							var pickView = new PickView({
									pickSummary: pickSum, 
									leagueInst: this.leagueInst,
									user: this.user,
									draftOptions: this.draftOptions,
									posColors: this.posColors,
									prodConfig: this.prodConfig,
									pickCollection: this.pickCollection,
									displayTeam: true});
							var builtEl = pickView.render().el;
							
							builtEl.find('.pickTeamOwner').html(this.leagueInst.getTeam(pickSum.get('fantasyTeamId')).get('teamName'));
							builtEl.find('.pickTeamOwner').show();
							
							roundRow.append(builtEl);
							this.pickViews[pickSum.get('id')] = pickView;
						} else {
							roundRow.append('<td class="emptyPickSpace">&nbsp;</td>');
						}
					}
					
					
					for (var j = 1; j <= (maxPicksInRound-roundPicks.length); j++) {
						roundRow.append('<td class="emptyPickSpace">&nbsp;</td>');
					}
					
					this.$("tbody").append(roundRow);
				}
			}
		}
	});
	
	var SnakeOrderView = Backbone.View.extend({
		el: $("#customSnakeDraftBoardTable"),
		
		initialize: function(options) {
			this.leagueInst = options.leagueInst;
			this.user = options.user;
			this.pickSummaries = options.pickSummaries;
			this.draftOptions = options.draftOptions;
			this.posColors = options.posColors;
			this.prodConfig = options.prodConfig;
			this.pickCollection = options.pickCollection;
			this.draftStatusModel = options.draftStatusModel;
			
			this.pickViews = [];
		},
		
		render: function () {		
			this.$("tbody").empty();
			this.renderRounds();
			
			//$('#draftBoardView').show();
			
			return this;
		},
		
		renderRounds: function () {
			var numRounds = this.leagueInst.get('numRounds');
			var numTeams = this.leagueInst.numTeams();
			
			if(this.leagueInst.get('draftType') == 'CUSTOM'){
				var picksPerRound = new Array(numRounds);
				var maxPicksInRound = 0;
				
				for (var i = 1; i <= numRounds; i++) {
					var roundPicks = this.pickCollection.getPicksByRound(i);
					
					if(roundPicks.length > maxPicksInRound){
						maxPicksInRound = roundPicks.length;
					}
						
					picksPerRound[i] = roundPicks;
				}
				
				for (var i = 1; i <= numRounds; i++) {
					var roundRow = $('<tr></tr>');
					
					var curRound = i;
					roundPicks = picksPerRound[i];
					
					roundRow.append('<td class="draftRound">' + i + '</td>');
					
					roundRow.find(".draftRound").css({
						'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
						'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
					
					for (var j = 1; j <= roundPicks.length; j++) {
						var posInRound = j;
						if(curRound % 2 == 0){
							posInRound = roundPicks.length - (j-1);
						}
						 
						var pickSum = this.pickSummaries.get(this.pickSummaries.getPosRoundId(curRound, posInRound));
						
						if(pickSum){
							var pickView = new PickView({
									pickSummary: pickSum, 
									leagueInst: this.leagueInst,
									user: this.user,
									draftOptions: this.draftOptions,
									posColors: this.posColors,
									prodConfig: this.prodConfig,
									pickCollection: this.pickCollection,
									displayTeam: true});
							var builtEl = pickView.render().el;
							
							builtEl.find('.pickTeamOwner').html(this.leagueInst.getTeam(pickSum.get('fantasyTeamId')).get('teamName'));
							builtEl.find('.pickTeamOwner').show();
							
							roundRow.append(builtEl);
							this.pickViews[pickSum.get('id')] = pickView;
						} else {
							roundRow.append('<td class="emptyPickSpace">&nbsp;</td>');
						}
					}
					
					for (var j = 1; j <= (maxPicksInRound-roundPicks.length); j++) {
						roundRow.append('<td class="emptyPickSpace">&nbsp;</td>');
					}
					
					this.$("tbody").append(roundRow);
				}
			}
		}
	});
	
	var DraftBoardView = Backbone.View.extend({
		el: $("#draftBoardTable"),
		
		initialize: function(options) {
			this.leagueInst = options.leagueInst;
			this.user = options.user;
			this.pickSummaries = options.pickSummaryCollection;
			this.draftOptions = options.draftOptions;
			this.posColors = options.posColors;
			this.prodConfig = options.prodConfig;
			this.pickCollection = options.pickCollection;
			this.draftStatusModel = options.draftStatusModel;
			
			this.pickViews = [];
			this.teamViews = [];
			
			this.snakeView = null;
			this.standardView = null;
			
			if(this.leagueInst.get('draftType') == 'CUSTOM'){
				this.snakeView = new SnakeOrderView({
					leagueInst: this.leagueInst,
					user: this.user,
					pickSummaries: this.pickSummaries,
					draftOptions: this.draftOptions,
					posColors: this.posColors,
					prodConfig: this.prodConfig,
					pickCollection: this.pickCollection,
					draftStatusModel: this.draftStatusModel});
				this.standardView = new StandardOrderView({
					leagueInst: this.leagueInst,
					user: this.user,
					pickSummaries: this.pickSummaries,
					draftOptions: this.draftOptions,
					posColors: this.posColors,
					prodConfig: this.prodConfig,
					pickCollection: this.pickCollection,
					draftStatusModel: this.draftStatusModel});
			}
		},
		
		render: function () {		
			this.$(".fantTeamNameRow").empty();
			this.$("tbody").empty();
			this.renderTeams();
			this.renderRounds();
			this.configBoard();
			
			$('#draftBoardView').show();
			
			if(this.leagueInst.get('draftType') == 'CUSTOM'){
				this.snakeView.render();
				this.standardView.render();
			}			
			
			return this;
		},
		
		renderTeams: function () {
			var sortedTeams = this.leagueInst.getTeamList();
			
			//if(this.leagueInst.get('draftType') != 'CUSTOM'){
			//	this.$(".fantTeamNameRow").append('<th>&nbsp;</th>');
			//}
			
			this.$(".fantTeamNameRow").append('<th>&nbsp;</th>');
			//this.$(".fantTeamNameRow").append('<th class="draftRound">&nbsp;</th>'); //Fixed Header Revert
			
			_.each(sortedTeams, function(team){
				var teamView = new TeamHeaderView({
						leagueUser: this.leagueInst.get("leagueUsers").get(team.get('leagueUserId')), 
						fantasyTeam: team,
						draftOptions: this.draftOptions,
						user: this.user,
						leagueInst: this.leagueInst,
						draftStatusModel: this.draftStatusModel});
				this.$(".fantTeamNameRow").append(teamView.render().el);
				this.teamViews[team.get('draftPosition')] = teamView;
			}, this);
		},
		
		renderRounds: function () {
			var numRounds = this.leagueInst.get('numRounds');
			var numTeams = this.leagueInst.numTeams();
			
			if(this.leagueInst.get('draftType') != 'CUSTOM'){
				for (var i = 1; i <= numRounds; i++) {
					var roundRow = $('<tr></tr>');
					
					roundRow.append('<td class="draftRound">' + i + '</td>');
					
					roundRow.find(".draftRound").css({
						'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
						'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
					
					for (var j = 1; j <= numTeams; j++) {
						var posInRound = j;
						var isSnake = this.leagueInst.get('draftType') == 'SNAKE' ? true : false;
						
						if(i % 2 == 0 && isSnake){
							posInRound = numTeams - (posInRound -1);
						}
						
						var pickSummaryModel = this.pickSummaries.get(this.pickSummaries.getPosRoundId(i, posInRound));
						var pickView = new PickView({
								pickSummary: pickSummaryModel, 
								leagueInst: this.leagueInst,
								user: this.user,
								draftOptions: this.draftOptions,
								posColors: this.posColors,
								prodConfig: this.prodConfig,
								pickCollection: this.pickCollection,
								displayTeam: false});
						roundRow.append(pickView.render().el);
						this.pickViews[pickSummaryModel.get('id')] = pickView;
					}
					
					this.$("tbody").append(roundRow);
				}
			} else {
				this.teamList = this.leagueInst.getTeamList();
				
				for (var i = 1; i <= numRounds; i++) {
					var roundRow = $('<tr></tr>');
					
					this.curRound = i;
					this.pickCount = {};
					this.maxNumPicks = 0;
					this.roundPicks = this.pickCollection.getPicksByRound(this.curRound);
					
					_.each(this.teamList, function(team){
						this.pickCount[team.get('id')] = 0;
					}, this);
					
					//Get number of picks each team has in this round
					_.each(this.roundPicks, function(pick) {
						this.pickCount[pick.get('fantasyTeamId')] = this.pickCount[pick.get('fantasyTeamId')] + 1;
					}, this);
					
					//Figure out the max number of picks a team has in this round
					_.each(this.teamList, function(team){
						if(this.maxNumPicks < this.pickCount[team.get('id')]){
							this.maxNumPicks = this.pickCount[team.get('id')]; 
						}
					}, this);
					
					roundRow.append('<td class="draftRound" rowspan="' + this.maxNumPicks + '">' + i + '</td>');
					
					roundRow.find(".draftRound").css({
						'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
						'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
					
					//Add a rows for the max number of picks in round.  The unused spots will be blank
					for (var j = 1; j <= this.maxNumPicks; j++) {
						this.curIteration = j;
						
						//Start new row for rounds that have teams with multiple picks
						if(this.curIteration > 1){
							this.$("tbody").append(roundRow);
							roundRow = $('<tr></tr>');
						}
						
						//Each team needs either a pick added to the board or a blank space for that spot
						for (var h = 1; h <= numTeams; h++) {
							var curDraftPosition = h;
							this.curTeam = this.leagueInst.getTeamByDraftPosition(curDraftPosition);
							
							//Find the specific pick.  Example 2nd pick in the third round for team X
							this.pick = null;
							this.loopOccurance = 0;
							_.each(this.roundPicks, function(pick){
								if(pick.get('fantasyTeamId') 
										&& pick.get('fantasyTeamId') == this.curTeam.get('id') 
										&& this.curIteration == (this.loopOccurance + 1)){
									this.pick = pick;
									this.loopOccurance = this.loopOccurance + 1;
								} else if(pick.get('fantasyTeamId') 
										&& pick.get('fantasyTeamId') == this.curTeam.get('id')){
									this.loopOccurance = this.loopOccurance + 1;
								}
							}, this);
							
							if(this.pick){
								var pickSummaryModel = this.pickSummaries.get(this.pickSummaries.getPosRoundId(this.pick.get('round'), this.pick.get('posInRound')));
								var pickView = new PickView({
										pickSummary: pickSummaryModel, 
										leagueInst: this.leagueInst,
										user: this.user,
										draftOptions: this.draftOptions,
										posColors: this.posColors,
										prodConfig: this.prodConfig,
										pickCollection: this.pickCollection,
										displayTeam: false});
								roundRow.append(pickView.render().el);
								this.pickViews[pickSummaryModel.get('id')] = pickView;
							} else {
								roundRow.append('<td class="emptyPickSpace">&nbsp;</td>');
							}
							
							delete this.curTeam;
							delete this.pick;
							delete this.loopOccurance;
						}
						delete this.curIteration;
						
					}
					
					this.$("tbody").append(roundRow);
					
					delete this.curRound;
					delete this.pickCount;
					delete this.maxNumPicks;
					delete this.roundPicks;
				}
			}
		},
		
		configBoard: function() {
			if(this.leagueInst.get('draftStatus') == 'PREDRAFT'){
				$('body').addClass('keeperMode');
			}
		}
	});
	
	return DraftBoardView;  
});